import { RootState } from '@app/index';

export const selectNotifications = ({ snackbar }: RootState) => snackbar.notifications;
